var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-app',{attrs:{"id":"test"}},[_c('ag-grid-vue',{staticClass:"ag-theme-balham-dark",staticStyle:{"width":"100%","height":"100%"},attrs:{"components":_vm.components,"columnDefs":_vm.columnDefs,"rowData":_vm.rowData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }